import setLogin from './setLogin'

export default [...setLogin]



// WEBPACK FOOTER //
// ./src/modules/login/chains/redirectToLogin.js